<template>
  <div class="m-5">
    <div class="flex items-center justify-between mb-10">
      <h2 class=" text-primary-500 mb-0">
        Calendar
      </h2>
      <div>
        <d-btn @click="showAddEventModal">
          + Add Event
        </d-btn>
      </div>
    </div>
    <ejs-schedule ref="scheduleObj" height="800px" :current-view="currentView" :time-scale="timeScale" :event-settings="eventSettings" :popup-open="onPopupOpen" :quick-info-templates="quickInfoTemplates" :event-rendered="onEventRendered">
      <e-views>
        <e-view option="Day" />
        <e-view option="Week" />
        <e-view option="Month" />
      </e-views>
    </ejs-schedule>
  </div>
</template>

<script>
  import {
    Day, Week, Month,
  } from '@syncfusion/ej2-vue-schedule';
  import { mapGetters } from 'vuex';
  import dataManager from '@resources/scripts/plugins/syncfusion/mainCalendar';
  import Vue from 'vue';
  import axios from 'axios';
  import EventModal from './components/EventModal.vue';
  import QuickInfoFooter from './components/QuickInfoFooter.html';
  import EventTemplate from './components/EventTemplate.vue';
  import QuickInfoContent from './components/QuickInfoContent.vue';

  export default {
    parent: true,
    provide: {
      schedule: [Day, Week, Month],
    },

    data() {
      const vm = this;
      return {
        timeScale: {
          enable: false,
        },
        currentView: 'Week',
        eventSettings: {
          dataSource: dataManager,
          template(e) {
            return {
              template: EventTemplate,
            };
          },
          fields: {
            id: 'id',
            subject: { name: 'name' },
            description: { name: 'description' },
            startTime: { name: 'dateTime' },
            endTime: { name: 'dateTime' },
          },
        },
        quickInfoTemplates: {
          content(e) {
            return {
              template: QuickInfoContent,
            };
          },
          footer(e) {
            return {
              template: Vue.component('footerTemplate', {
                data() {
                  return {
                    data: {},
                    mainVm: vm,
                  };
                },
                computed: {
                  ...mapGetters('d2Auth', ['profile', 'hasRole']),
                },
                methods: {
                  showDeletePrompt() {
                    this.$dialog.confirm({
                      title: 'Deleting Event',
                      message: `Are you sure you want to delete <b>${this.data.name}</b>? This action cannot be undone.`,
                      confirmText: 'Delete Event',
                      confirmColor: 'error',
                      onConfirm: async () => {
                        await axios.delete(`/api/calendar-items/${this.data.id}`);
                        this.mainVm.$refs.scheduleObj.refreshEvents();
                        this.$toast.success(`${this.data.name} was deleted`);
                      },
                    });
                  },
                },
                template: QuickInfoFooter,
              }),
            };
          },
        },
      };
    },

    methods: {
      showAddEventModal(args = {}) {
        if (!args.data) {
          args.data = {
            startTime: new Date(),
          };
        }
        this.$modal.open({
          parent: this,
          component: EventModal,
          props: {
            newItem: args.data,
          },
          hasModalCard: true,
          events: {
            refreshEvents: () => this.$refs.scheduleObj.refreshEvents(),
          },
        });
      },

      showEditEventModal(args) {
        this.$modal.open({
          parent: this,
          component: EventModal,
          hasModalCard: true,
          props: {
            calendarItem: args.data,
          },
          events: {
            refreshEvents: () => this.$refs.scheduleObj.refreshEvents(),
          },
        });
      },

      onPopupOpen(args) {
        if (args.type === 'Editor' && args.data.id) {
          args.cancel = true;
          this.showEditEventModal(args);
        } else if (args.type === 'Editor' || (args.type === 'QuickInfo' && !args.data.id)) {
          args.cancel = true;
          this.showAddEventModal(args);
        }
      },

      onEventRendered(args) {
        if (!args.element || !args.data.owner) {
          return;
        }

        if (this.currentView === 'Agenda') {
          args.element.firstChild.style.borderLeftColor = args.data.owner.colorCode;
        } else {
          args.element.style.backgroundColor = args.data.owner.colorCode;
        }
      },
    },
  };
</script>